export const styles = {
  actions: 'hidden lg:flex',
};
